import { initialErrors } from "../Constants/Purchased-history-histories.constants";
import { Types } from "../Constants/Types";
import OrderHistoryType from "../Interfaces/purchased-history-histories.interface";

const OrderHistoryReducer = (state: OrderHistoryType['status'] = { 
        orderHistory: undefined,
        orderHistories: [],
        results: [],
        lorderHistories: false,
        pages: 0,
        resultPages: 0,
        error: initialErrors
    },
    action: OrderHistoryType['action']
    ) => {

    switch (action.type) {

        case Types.PH_SEARCH_ORDER_HISTORIES:
            return {...state, results: action.payload, resultPages: action.pages};

        case Types.PH_FETCH_ORDER_HISTORIES:
            return {...state, orderHistories: action.payload};

        case Types.PH_FETCH_ORDER_HISTORY:
            return {...state, orderHistory: action.payload};

        case Types.PH_CREATE_ORDER_HISTORY:
            return {...state, orderHistories: [action.payload, ...state.orderHistories]};

        case Types.PH_UPDATE_ORDER_HISTORY: 
            return {...state, orderHistories: state.orderHistories.map(orderHistory => orderHistory._id === action.payload.id ? action.payload : orderHistory)};
        
        case Types.PH_STATE_ORDER_HISTORY: 
            return {...state, orderHistories: state.orderHistories.map(orderHistory => orderHistory._id === action.payload.id ? {...orderHistory, ...action.payload} : orderHistory), orderHistory: {...state.orderHistory, state: action.payload.state}};

        case Types.PH_DELETE_ORDER_HISTORY: 
            return {...state, orderHistories: state.orderHistories.filter(orderHistory => orderHistory._id !== action.payload)}

        case Types.PH_START_ORDER_HISTORIES:
            return {...state, lorderHistories: true};

        case Types.PH_END_ORDER_HISTORIES:
            return {...state, lorderHistories: false};

        case Types.PH_ERROR_ORDER_HISTORY:
            return {...state, error: action?.payload ? {...state.error, [action?.field!]: action.payload} : {...state.error, [action?.field!]: null}};

        case Types.PH_RESET_ORDER_HISTORY:
            return {...state, error: initialErrors}

        default: 
            return state
    }
}

export default OrderHistoryReducer;